import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ccbb474a&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=ccbb474a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbb474a",
  null
  
)

export default component.exports